// extracted by mini-css-extract-plugin
export default {"container":"_d9d5f5f1","bid":"_fa01d479","priceInfo":"_dfca9b5","bidDetails":"_a53c889b","originalListPrice":"_c74b6800","printHide":"_acfca5a7"};